// @flow
// $FlowFixMe
import React, { memo } from "react";
import type { UnaryFn } from "@tvg/types/Functional";
import { noop } from "lodash";
import buildColor from "@fdr/static-ui/ColorPalette";
import { arrowDown } from "@fdr/static-ui/Icons/icons";

import {
  Container,
  ButtonContainer,
  HighlightedContainer,
  TrackNameContainer,
  RaceNumberContainer,
  IconWrapper
} from "./styled-components";
import Button from "../../_atoms/Button/index";

type Props = {
  isHeaderSelector: boolean,
  trackName: string,
  raceNumber: string,
  highlightedText: string,
  trackSelectorUrl: string,
  openTrackSelector: UnaryFn<string, void>
};

const renderButton = (props: Props) => {
  const {
    trackName,
    raceNumber,
    openTrackSelector,
    highlightedText,
    isHeaderSelector,
    trackSelectorUrl
  } = props;

  const getButtonSize = () => {
    if (isHeaderSelector) {
      return "noSize";
    }
    if (highlightedText) {
      return "small";
    }
    return "medium";
  };

  return (
    <Button
      type="fanduel"
      size={getButtonSize()}
      onClick={openTrackSelector}
      isInternalLink
      url={trackSelectorUrl}
      borderLess
      paddingLess
    >
      <ButtonContainer>
        <TrackNameContainer
          isHeaderSelector={isHeaderSelector}
          isSmall={!!highlightedText}
        >
          {trackName}
        </TrackNameContainer>
        <RaceNumberContainer
          isHeaderSelector={isHeaderSelector}
          isSmall={!!highlightedText}
        >
          R{raceNumber}
        </RaceNumberContainer>
        <IconWrapper icon={arrowDown} color={buildColor("blue", "400")} />
      </ButtonContainer>
    </Button>
  );
};

const TrackSelector = memo((props: Props) => {
  const { highlightedText, isHeaderSelector } = props;
  return (
    <Container isHeaderSelector={isHeaderSelector}>
      {!!highlightedText && !isHeaderSelector && (
        <HighlightedContainer>{highlightedText}</HighlightedContainer>
      )}
      {renderButton(props)}
    </Container>
  );
});

TrackSelector.defaultProps = {
  trackName: "",
  raceNumber: "",
  isHeaderSelector: false,
  highlightedText: "",
  trackSelectorUrl: "",
  openTrackSelector: noop
};
export default TrackSelector;
